var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading && _vm.shouldShow)?_c('div',[_c('div',{class:_vm.$style.loading},[_c('ElementLoading',{attrs:{"color":"primary"}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }